import { Role } from './role';

export interface LoginResponse {
    access_token: string;
    data: any;
    name: string;
    status: string;
    message: string;
}

export class User {
  	public id: number;
  	public username: string;
  	public publicIdentity: string;
  	public email: string;
    public userProfile: any = {};
    public roles: any[] = [];
    public t_hrs: number;
    public t_km: number;

  	constructor(
  	) {}
}
